import { z } from 'zod/v4';

import { ZOD_ERROR } from '../models/constants';
import { BaseMessage, baseMessageSchema } from './base-message.schema';
import { notifyAssetResultSchema } from './notify-asset-result.schema';

const notifyAssetOperationSchema = z.object({
  id: z.string(),
  type: z.string(),
  result: notifyAssetResultSchema,
});

export const notifyAssetOperationEventSchema = baseMessageSchema.transform(
  (data) => {
    const message = JSON.parse(data.message) as BaseMessage;
    const { success, data: result } =
      notifyAssetOperationSchema.safeParse(message);

    if (success) {
      return result;
    }

    return {
      type: '',
      id: '',
      result: {
        errorCode: ZOD_ERROR,
        totalMessagesSent: 0,
        totalMessageFailures: 0,
      },
    };
  }
);
